import role from '@/auth/role'

export default [
  {
    path: '/organization/calendar',
    name: 'organization-calendar',
    component: () => import('@/views/organization/calendar/Calendar.vue'),
    meta: {
      title: 'navigation.calendar',
      access: [role.educator],
      pageTitle: 'navigation.calendar',
      breadcrumb: [
        {
          text: 'navigation.calendar',
          active: true,
        },
      ],
    },
  },
]
